<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-start align-items-center">
            <h1 class="mx-1">
                <span>Documente încărcate

                </span>


            </h1>
        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

</div>

<div class="box-content-body">

    <div class="p-3" *ngFor="let docTypeKey of getDocumentTypeKeys()">

        <button  type="button" class="btn btn-light upload-btn">
            <span class="upload__text">
                <i class="fa-solid fa-layer-group"></i> &nbsp;
                {{
                data?.documente?.[docTypeKey]?.name }}
            </span>
        </button>
        <div class="p-2">
            <mat-divider></mat-divider>
        </div>

        <div class="p-3" *ngFor="let docKey of getDocumentKeys(docTypeKey)">
            <mat-card-subtitle>{{ data?.documente?.[docTypeKey]?.documente?.[docKey]?.name }}
            </mat-card-subtitle>
            <div class="p-2">
                <mat-divider></mat-divider>
            </div>
            <div class="docs d-flex flex-row justify-content-start align-items-center flex-wrap">
                <button type="button" class="btn btn-light upload-btn m-2"
                    *ngFor="let file of data?.documente?.[docTypeKey]?.documente?.[docKey]?.files"
                    (click)="downloadDocument(file)">
                    <span class="upload__text">
                        <img src="assets/icons/icon-download-blue.svg" alt="Descarcă" />
                        &nbsp;{{ file.name }}
                    </span>
                </button>
            </div>
        </div>
    </div>